import * as React from 'react';

const DEFAULT_TAG = "div";
const FlexItem = React.forwardRef(function FlexItem2(props, ref) {
  const {
    component: Component = DEFAULT_TAG,
    order = 0,
    flexShrink = 1,
    flexGrow = 0,
    alignSelf = "auto",
    flexBasis = 0,
    forwardRef = ref,
    style = {},
    ...rest
  } = props;
  return /* @__PURE__ */ React.createElement(Component, {
    ref: forwardRef,
    style: { order, flexShrink, flexGrow, flexBasis, alignSelf, ...style },
    ...rest
  });
});

export { FlexItem };
